import { Table } from '@/components';
import {
  TablePaginationComp,
  type PaginationConfig,
} from '@/components/table/TablePagination';
import useRoutesTable from '../hooks/useRoutesTable';
import {
  ROUTES_TABLE_CARD_CLASS,
  ROUTES_TABLE_ROWS_PER_PAGE_OPTIONS,
  ROUTES_TABLE_SKELETON_ACTIONS_PLACEHOLDER_CLASS,
} from '../constants/routesTable.constants';
import type { Route } from '../models/Route';
import ExpandableRoutesTable from './routesTable/ExpandableRoutesTable';

interface RoutesTableProps {
  routes: Route[];
  isLoading: boolean;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  commerceTableFilter?: { commerceName: string };
  syncVisitSearchFromRouteShippingNumber?: string;
}

const RoutesTable = ({
  routes,
  isLoading,
  totalItems,
  totalPages,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
  commerceTableFilter,
  syncVisitSearchFromRouteShippingNumber,
}: RoutesTableProps) => {
  const table = useRoutesTable({ routes, currentPage, commerceTableFilter });

  const pagination: PaginationConfig = {
    totalItems,
    totalPages,
    currentPage,
    rowsPerPage: pageSize,
    onPageChange,
    onRowsPerPageChange: onPageSizeChange,
    rowsPerPageOptions: [...ROUTES_TABLE_ROWS_PER_PAGE_OPTIONS],
  };

  return (
    <div className={ROUTES_TABLE_CARD_CLASS}>
      <div className='overflow-x-auto'>
        {isLoading ? (
          <Table
            columns={table.columns}
            data={[]}
            isLoading
            skeletonRows={pageSize}
            selectedSort={table.selectedSort}
            handleSort={table.handleSort}
            renderActions={() => (
              <span
                className={ROUTES_TABLE_SKELETON_ACTIONS_PLACEHOLDER_CLASS}
                aria-hidden
              />
            )}
            pagination={pagination}
          />
        ) : (
          <>
            <ExpandableRoutesTable
              columns={table.columns}
              rows={table.rows}
              expandedIds={table.expandedIds}
              selectedSort={table.selectedSort}
              handleSort={table.handleSort}
              renderActions={table.renderActions}
              syncVisitSearchFromRouteShippingNumber={
                syncVisitSearchFromRouteShippingNumber
              }
            />
            <TablePaginationComp {...pagination} />
          </>
        )}
      </div>
    </div>
  );
};

export default RoutesTable;
